export default "__VITE_ASSET__C6gPeEo4__"